import { render, staticRenderFns } from "./RegisAOI.vue?vue&type=template&id=25b42197&scoped=true&"
import script from "./RegisAOI.vue?vue&type=script&lang=js&"
export * from "./RegisAOI.vue?vue&type=script&lang=js&"
import style0 from "./RegisAOI.vue?vue&type=style&index=0&id=25b42197&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b42197",
  null
  
)

export default component.exports